import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

export interface SelectTransplantDialogData {
  chainNumber: string;
  matchRunNumber: string;
}

export interface SelectTransplantDialogResult {
  confirmed: boolean;
}

@Component({
  selector: 'app-select-transplant-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Confirm Selection for Transplantation: {{ data.matchRunNumber }}:{{ data.chainNumber }}</h2>
    <mat-dialog-content>
      <p>
        Selecting this chain for transplantation will notify centers of the intended transplant and allows insight in the donors matched to their recipients. It is possible to later unselect the chain.
      </p>
      <p class="warning-note">
        <strong>Note:</strong> All participants in this chain receive a permanent 'Selected for Transplantation' status in the Participants screen and cannot be modified until unselected.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onConfirm()">
        Confirm Select
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      max-width: 600px;
      min-width: 500px;
      padding: 20px 24px;
    }
    mat-dialog-content p {
      margin-bottom: 16px;
      line-height: 1.5;
    }
    .warning-note {
      color: #d32f2f;
      font-weight: 500;
    }
    mat-dialog-actions {
      padding: 16px 24px;
    }
  `]
})
export class SelectTransplantDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SelectTransplantDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectTransplantDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }

  onConfirm(): void {
    this.dialogRef.close({ confirmed: true });
  }
}
